// 海角黑料 · 首页静态演示数据
// 说明：本文件为纯展示用示例内容，话题均为泛化的舆论现象描述，不指向任何真实个人或机构。

export const siteMeta = {
  name: '海角黑料',
  slogan: '热议 · 争议 · 观点 · 态度',
  issue: '第 148 期',
  date: '2026 年 9 月 10 日 星期四',
  intro: '跟踪热议动态，汇总各方评论、观点与态度，记录舆论发酵中的多元评价。',
};

export interface TickerItem {
  id: number;
  time: string;
  text: string;
  hot: boolean;
}

export const tickerItems: TickerItem[] = [
  { id: 1, time: '09:40', text: '剪辑争议迎来第三轮回应，评论区态度出现明显分化', hot: true },
  { id: 2, time: '09:12', text: '联名款定价质疑冲上热度榜首位，围观群众开始摆数据', hot: true },
  { id: 3, time: '08:55', text: '旧访谈片段被重新翻出，网友对语境理解各不相同', hot: false },
  { id: 4, time: '08:31', text: '粉丝控评现象被集中讨论，路人与粉丝立场泾渭分明', hot: false },
  { id: 5, time: '08:04', text: '番位之争话题降温，理性分析帖开始占据前排', hot: false },
  { id: 6, time: '07:47', text: '直播口误事件双方致意，事件热度回落但余波仍在', hot: false },
];

export const navItems: { label: string; href: string; anchor: string }[] = [
  { label: '首页', href: '#top', anchor: 'top' },
  { label: '今日热议', href: '#hot-wall', anchor: 'hot-wall' },
  { label: '热度榜', href: '#ranking', anchor: 'ranking' },
  { label: '观点对撞', href: '#clash', anchor: 'clash' },
  { label: '围观评论', href: '#comments', anchor: 'comments' },
  { label: '后续追踪', href: '#timeline', anchor: 'timeline' },
];

export interface LeadStory {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  image: string;
  heat: string;
  comments: string;
  follow: number;
}

export const leadStory: LeadStory = {
  id: 'lead',
  tag: '封面话题',
  title: '剪辑争议持续发酵：同一段画面，为何各方读出的态度完全不同',
  excerpt:
    '一段被反复截取的画面，在三天内衍生出至少四种解读路径。支持者强调语境缺失，质疑者聚焦呈现手法，围观群众则把注意力放在了评论区本身。这里汇总了目前能看到的全部观点层次。',
  image:
    'https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20collage%20of%20overlapping%20paper%20scraps%20in%20warm%20cream%20and%20deep%20vermillion%20red%2C%20subtle%20grain%20texture%2C%20soft%20studio%20lighting%2C%20minimal%20artistic%20composition%2C%20high%20detail&width=1200&height=760&seq=hj-cover-lead-01&orientation=landscape',
  heat: '98.6 万',
  comments: '2.4 万',
  follow: 86,
};

export interface SideStory {
  id: string;
  index: number;
  tag: string;
  title: string;
  meta: string;
  image: string;
}

export const sideStories: SideStory[] = [
  {
    id: 'side-1',
    index: 1,
    tag: '品牌',
    title: '联名款定价被质疑，围观群众开始逐条比对成本清单',
    meta: '热度 84.2 万 · 评论 1.1 万',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20a%20plain%20packaging%20box%20on%20warm%20cream%20paper%20background%2C%20soft%20shadow%2C%20muted%20amber%20accent%2C%20clean%20studio%20photography%2C%20high%20detail&width=600&height=600&seq=hj-side-01&orientation=squarish',
  },
  {
    id: 'side-2',
    index: 2,
    tag: '综艺',
    title: '番位之争降温，理性长帖反而冲上了讨论区前排',
    meta: '热度 61.5 万 · 评论 8,420',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20stage%20spotlight%20with%20warm%20amber%20glow%20on%20cream%20backdrop%2C%20minimal%20editorial%20photography%2C%20soft%20gradient%2C%20grain%20texture%2C%20high%20detail&width=600&height=600&seq=hj-side-02&orientation=squarish',
  },
  {
    id: 'side-3',
    index: 3,
    tag: '直播',
    title: '一次口误引发的连锁反应：从道歉到双方致意只用了半天',
    meta: '热度 47.9 万 · 评论 5,306',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20brown%20microphone%20silhouette%20on%20cream%20background%20with%20soft%20amber%20rim%20light%2C%20minimal%20editorial%20product%20photography%2C%20clean%20composition%2C%20high%20detail&width=600&height=600&seq=hj-side-03&orientation=squarish',
  },
];

export interface TopicItem {
  id: string;
  label: string;
  count: number;
  level: '爆' | '热' | '新' | '议';
}

export const topicWall: TopicItem[] = [
  { id: 't1', label: '剪辑争议', count: 98600, level: '爆' },
  { id: 't2', label: '联名款定价', count: 74200, level: '热' },
  { id: 't3', label: '粉丝控评', count: 63800, level: '热' },
  { id: 't4', label: '旧访谈翻出', count: 52100, level: '议' },
  { id: 't5', label: '番位之争', count: 48000, level: '议' },
  { id: 't6', label: '直播口误', count: 41200, level: '新' },
  { id: 't7', label: '回应时机', count: 35600, level: '议' },
  { id: 't8', label: '数据打假', count: 31800, level: '新' },
  { id: 't9', label: '评论区生态', count: 29400, level: '议' },
  { id: 't10', label: '代言续约', count: 25600, level: '新' },
  { id: 't11', label: '通稿措辞', count: 22300, level: '议' },
  { id: 't12', label: '路转粉', count: 19800, level: '新' },
  { id: 't13', label: '二次创作', count: 17600, level: '新' },
  { id: 't14', label: '热搜轨迹', count: 15400, level: '议' },
  { id: 't15', label: '态度对比', count: 13200, level: '议' },
];

export interface RankItem {
  rank: number;
  title: string;
  heat: string;
  delta: 'up' | 'down' | 'flat';
  deltaText: string;
  category: string;
}

export const heatRanking: RankItem[] = [
  { rank: 1, title: '剪辑争议迎来第三轮回应', heat: '98.6 万', delta: 'up', deltaText: '+12', category: '综艺' },
  { rank: 2, title: '联名款定价成本逐条比对', heat: '84.2 万', delta: 'up', deltaText: '+5', category: '品牌' },
  { rank: 3, title: '粉丝控评现象集中讨论', heat: '63.8 万', delta: 'down', deltaText: '-2', category: '舆情' },
  { rank: 4, title: '旧访谈片段语境之争', heat: '52.1 万', delta: 'flat', deltaText: '0', category: '访谈' },
  { rank: 5, title: '番位之争理性长帖上分', heat: '48.0 万', delta: 'up', deltaText: '+8', category: '综艺' },
  { rank: 6, title: '直播口误双方致意收场', heat: '41.2 万', delta: 'down', deltaText: '-6', category: '直播' },
  { rank: 7, title: '回应时机是否过晚引发讨论', heat: '35.6 万', delta: 'up', deltaText: '+3', category: '舆情' },
  { rank: 8, title: '数据打假帖阅读量反超原帖', heat: '31.8 万', delta: 'flat', deltaText: '0', category: '数据' },
];

export interface ClashSide {
  camp: string;
  ratio: number;
  stance: string;
  points: string[];
}

export interface ClashTopic {
  topic: string;
  heatLine: string;
  left: ClashSide;
  right: ClashSide;
}

export const clashTopic: ClashTopic = {
  topic: '剪辑争议究竟该由谁来解释',
  heatLine: '当前两方声量接近，中立观望者比例小幅上升',
  left: {
    camp: '认为应聚焦呈现手法',
    ratio: 46,
    stance: '同一段素材被截取后，语境变化足以改变态度判断',
    points: ['截取位置影响理解', '前后文缺失是核心', '应公开完整版本'],
  },
  right: {
    camp: '认为应关注当事人表达',
    ratio: 41,
    stance: '画面只是载体，真正被讨论的是当事人的真实态度',
    points: ['表达本身足够清晰', '多次回应口径不一', '重点不在剪辑技术'],
  },
};

export const clashNeutral = {
  camp: '暂不站队 · 观望中',
  ratio: 13,
  stance: '等更多事实与完整时间线出现，再决定态度',
};

export interface CommentItem {
  id: string;
  user: string;
  avatarText: string;
  topic: string;
  content: string;
  likes: number;
  side: '支持' | '质疑' | '中立';
}

export const commentPicks: CommentItem[] = [
  {
    id: 'c1',
    user: '围观不发言',
    avatarText: '围',
    topic: '剪辑争议',
    content:
      '这两天把四个版本的片段都看了一遍，说实话每次理解都不一样。与其吵谁对谁错，不如把完整版先放出来，大家心里都有数。',
    likes: 4820,
    side: '中立',
  },
  {
    id: 'c2',
    user: '摆数据的老张',
    avatarText: '张',
    topic: '联名款定价',
    content:
      '把公开的成本项逐条列了一下，其实争议不在于贵不贵，而在于前后两次的说法对不上。数据摆在这，大家自己看。',
    likes: 3960,
    side: '质疑',
  },
  {
    id: 'c3',
    user: '今天也要冷静',
    avatarText: '冷',
    topic: '粉丝控评',
    content:
      '评论区前排清一色同一句话的时候，反而让人好奇真实的路人怎么想。控评本身没问题，把讨论空间挤没了才是问题。',
    likes: 3310,
    side: '中立',
  },
  {
    id: 'c4',
    user: '只看作品的人',
    avatarText: '作',
    topic: '番位之争',
    content:
      '追了这么多年，番位真的没那么重要。作品立得住，排在第二个观众照样记得你，站第一但没人看也是白搭。',
    likes: 2740,
    side: '支持',
  },
  {
    id: 'c5',
    user: '时间线整理君',
    avatarText: '时',
    topic: '旧访谈翻出',
    content:
      '那句被截出来的话原文后面还有半句，语境完全不同。建议大家点进完整访谈再下结论，别被一句话带走。',
    likes: 2180,
    side: '支持',
  },
  {
    id: 'c6',
    user: '路人甲乙丙',
    avatarText: '路',
    topic: '回应时机',
    content:
      '其实大家不满的不是回应内容，是拖了太久。事情刚起的时候说一句，可能就没有后面这么多轮了。',
    likes: 1650,
    side: '质疑',
  },
];

export interface TimelineItem {
  id: string;
  day: string;
  time: string;
  title: string;
  desc: string;
  type: '起' | '升' | '转' | '落';
}

export const followUpTimeline: TimelineItem[] = [
  {
    id: 'tl1',
    day: '9 月 8 日',
    time: '14:20',
    title: '话题首次出现',
    desc: '一段截取画面在讨论区出现，最初只在少数账号内传播，尚未形成统一解读。',
    type: '起',
  },
  {
    id: 'tl2',
    day: '9 月 8 日',
    time: '21:05',
    title: '热度快速攀升',
    desc: '不同立场的解读帖开始并行出现，评论区迅速分化为两到三个主要阵营。',
    type: '升',
  },
  {
    id: 'tl3',
    day: '9 月 9 日',
    time: '10:40',
    title: '完整素材被补充',
    desc: '完整版本被放上讨论区，此前部分争议点得到部分解答，但新的分歧随之产生。',
    type: '转',
  },
  {
    id: 'tl4',
    day: '9 月 9 日',
    time: '19:30',
    title: '多方给出回应',
    desc: '相关方先后给出说明，口径存在细微差异，成为围观群众新的讨论焦点。',
    type: '转',
  },
  {
    id: 'tl5',
    day: '9 月 10 日',
    time: '09:40',
    title: '热度回落但余波未平',
    desc: '整体热度较峰值下降，但关于"回应时机"与"措辞"的讨论仍在持续。',
    type: '落',
  },
];

export interface RadarAxis {
  axis: string;
  score: number;
}

export const controversyRadar: RadarAxis[] = [
  { axis: '话题热度', score: 96 },
  { axis: '立场分化', score: 88 },
  { axis: '事实清晰度', score: 54 },
  { axis: '回应充分度', score: 61 },
  { axis: '情绪浓度', score: 82 },
  { axis: '后续关注', score: 74 },
];

export const focusPoints: string[] = [
  '完整素材公开后，争议焦点已从"是否剪辑"转向"回应口径"',
  '中立观望者比例三日来持续小幅上升，从 9% 升至 13%',
  '讨论高峰期集中在每日 20:00 至 23:00 时段',
];

export const statBar: { label: string; value: string; note: string }[] = [
  { label: '今日收录话题', value: '128', note: '较昨日 +16' },
  { label: '观点汇总条数', value: '4,286', note: '含评论与长帖' },
  { label: '追踪中的事件', value: '37', note: '持续更新中' },
  { label: '围观讨论人数', value: '62.4 万', note: '近 24 小时' },
];

export const issueHighlights: string[] = [
  '本期封面聚焦剪辑争议的多元解读',
  '热度榜前三名较昨日全部发生位次变化',
  '观点对撞首次引入"中立观望"独立阵营',
];